import { InspectionStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class SgsTuvData {
    @ApiProperty()
    soInspectionId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    shipmentDate: Date;
    @ApiProperty()
    initiationDate: Date;
    @ApiProperty()
    plannedDate: Date;
    @ApiProperty()
    actualDate: Date;
    @ApiProperty()
    expectedResultDate: Date;
    @ApiProperty()
    inspectionStatus:InspectionStatusEnum;
}